import React from 'react'
import PropTypes from 'prop-types'
import {
    Text,
    HStack,
    Box,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {useIntl} from 'react-intl'
import InfoPopover from '../popovers/info-popover'
import {EcoPartIcon, InfoIcon} from '../icons'

const WeeeFee = ({price = '', variant = 'default', itemCurrency = '', showInfoPopover = true}) => {
    const styles = useMultiStyleConfig('WeeeFee', {variant})
    const {currency} = useCurrency()
    const intl = useIntl()
    const currentPriceText = intl.formatNumber(price, {
        style: 'currency',
        currency: itemCurrency || currency,
    })

    const label =
        variant === 'default'
            ? intl.formatMessage(
                  {
                      id: 'weee_fee.included',
                      defaultMessage: '{currentPriceText} d’eco-part',
                  },
                  {currentPriceText},
              )
            : variant === 'productView'
            ? intl.formatMessage(
                  {
                      id: 'weee_fee.product_view',
                      defaultMessage: "{currentPriceText} D'eco-part:",
                  },
                  {currentPriceText},
              )
            : variant === 'orderHistory'
            ? intl.formatMessage(
                  {
                      id: 'weee_fee.orderHistory',
                      defaultMessage: '{currentPriceText} Eco tax',
                  },
                  {currentPriceText},
              )
            : intl.formatMessage({
                  id: 'weee_fee.orderSummary',
                  defaultMessage: 'Eco tax',
              })

    return (
        <HStack {...styles.weeeFeeContainer} alignItems="center">
            <HStack {...styles.weeeFeeLabel} alignItems="center">
                {variant === 'productView' ? (
                    <>
                        <Box {...styles.leadingIconContainer}>
                            <EcoPartIcon {...styles.leadingIcon} />
                        </Box>

                        <Text {...styles.weeeFeeBadgeText}>{label}</Text>

                        {showInfoPopover && (
                            <InfoPopover
                                trigger={
                                    <Box {...styles.infoIconContainer}>
                                        <InfoIcon {...styles.infoIcon} />
                                    </Box>
                                }
                                variant="right-center"
                                openTooltipOn="hover"
                                title={intl.formatMessage({
                                    id: 'weee-fee.info.popover.title',
                                    defaultMessage: 'Weee-fee Popover Title',
                                })}
                                description={intl.formatMessage({
                                    id: 'weee-fee.info.popover.description',
                                    defaultMessage: 'Weee-fee Popover Description',
                                })}
                            />
                        )}
                    </>
                ) : (
                    <>
                        <Text {...styles.weeeFeeText}>{label}</Text>

                        {showInfoPopover && (
                            <InfoPopover
                                trigger={
                                    <Box {...styles.infoIconContainer}>
                                        <InfoIcon {...styles.infoIcon} />
                                    </Box>
                                }
                                variant="right-center"
                                openTooltipOn="hover"
                                title={intl.formatMessage({
                                    id: 'weee-fee.info.popover.title',
                                    defaultMessage: 'Weee-fee Popover Title',
                                })}
                                description={intl.formatMessage({
                                    id: 'weee-fee.info.popover.description',
                                    defaultMessage: 'Weee-fee Popover Description',
                                })}
                            />
                        )}
                    </>
                )}
            </HStack>
            {variant !== 'default' && variant !== 'orderHistory' && variant !== 'productView' && (
                <Text {...styles.weeeFeeText}>{currentPriceText}</Text>
            )}
        </HStack>
    )
}

WeeeFee.propTypes = {
    variant: PropTypes.string,
    price: PropTypes.number,
    itemCurrency: PropTypes.string,
    showInfoPopover: PropTypes.bool,
}
export default WeeeFee
